<template>
  <div class="user-list-section-container">
    <!-- Badges de seleccionados -->
    <div v-if="left_selected_user.length > 0" class="selected-badges-container">
      <div class="selected-badges-header">
        <ButtonSmall
          v-if="left_selected_user.length > 1"
          :tooltip_text="$t('reusable.common.clearSelected')"
          :text_button="``"
          :click_button="clearAllSelected"
          :icon="'clean'"
          :variant="'none'"
          :custom_class="'mr-2 clean-all'"
        >
        </ButtonSmall>
        <b-icon-check-circle-fill class="mr-2"></b-icon-check-circle-fill>
        <span
          ><strong>{{ left_selected_user.length }}</strong>
          {{ $t("section.sectionView.selected").toLowerCase() }}:</span
        >
      </div>
      <div class="selected-badges-list">
        <b-badge
          variant="primary"
          pill
          class="badge-user-selected"
          v-for="selected_user in left_selected_user"
          :key="`selected-${selected_user.id}`"
          v-b-tooltip.v-secondary.noninteractive.top="
            `${selected_user.first_name} ${selected_user.last_name} ${selected_user.user_data?.identifier}`
          "
        >
          <strong>
            {{
              String(selected_user.first_name + " " + selected_user.last_name)
                .trim()
                .split(/\s+/)
                .map((word) => word[0].toUpperCase())
                .join("")
            }}
          </strong>
          <b-icon
            icon="x"
            class="ml-1 close-badge-icon"
            @click="changeSelectedAvaible(selected_user)"
          ></b-icon>
        </b-badge>
      </div>
    </div>

    <div class="tables-grid">
      <!-- Tabla Disponibles -->
      <div class="table-card available-card">
        <div class="table-card-header">
          <div class="header-title">
            <b-icon-people class="mr-2"></b-icon-people>
            <span>{{ $t("reusable.common.available") }}</span>
          </div>
          <ButtonSmall
            :tooltip_text="``"
            :text_button="$t('section.sectionView.emailQuickSearchTitle')"
            :click_button="openEmailSearchModal"
            :icon="'search'"
            :variant="'light'"
            :custom_class="'p-1'"
          >
          </ButtonSmall>
        </div>
        <div class="table-card-body">
          <NewGenericBTable
            ref="available_table"
            :display_id="'NewGenericBTable' + key_component"
            :key="generic_table_key"
            :search_filter="true"
            :columns_display="true"
            :fields="fields"
            :pre_filter="pre_filter"
            :pre_current_page="current_page"
            :pre_multiple_search="current_tag"
            @current_page="currentPage"
            @current_tag="currentTag"
            :url="available_users_url"
            @actual_items="actualItems"
          >
            <template #head(selected)>
              <div class="d-flex text-left" v-if="filter_by_student">
                <b-checkbox
                  :checked="all_selected"
                  @change="checkSelectAll"
                  v-b-tooltip.top.v-secondary.noninteractive="{
                    title: $t('reusable.common.selectAll'),
                    boundary: 'viewport',
                  }"
                ></b-checkbox>
              </div>
            </template>
            <template #cell(selected)="row">
              <div class="d-flex">
                <b-checkbox
                  class="ml-auto mr-auto"
                  :checked="left_selected_user.some((x) => x.id == row.item.id)"
                  @change="changeSelectedAvaible(row.item)"
                ></b-checkbox>
              </div>
            </template>
            <template #cell(name)="row">
              {{ row.item.first_name }} {{ row.item.last_name }}
            </template>
            <template #cell(egress_profile)="row">
              <span v-if="row.item.student_card">
                {{ getEgressProfileName(row.item.student_card.egress_profile) }}
              </span>
            </template>
          </NewGenericBTable>
        </div>
      </div>

      <!-- Botones de Control -->
      <div class="transfer-buttons-container" v-if="allows_crud">
        <button
          class="transfer-button transfer-button-right"
          @click="moveToSelected"
          :disabled="left_selected_user.length === 0"
          v-b-tooltip.top.v-secondary.noninteractive="{
            title: $t('reusable.common.addSelected'),
            boundary: 'viewport',
          }"
        >
          <b-icon-arrow-right scale="1.2"></b-icon-arrow-right>
        </button>
        <button
          class="transfer-button transfer-button-left"
          @click="moveToUnSelected"
          :disabled="right_selected_user.length === 0"
          v-b-tooltip.top.v-secondary.noninteractive="{
            title: $t('reusable.common.removeSelected'),
            boundary: 'viewport',
          }"
        >
          <b-icon-arrow-left scale="1.2"></b-icon-arrow-left>
        </button>
      </div>
      <div v-else class="transfer-spacer"></div>

      <!-- Tabla Asignados -->
      <div class="table-card assigned-card">
        <div class="table-card-header">
          <div class="header-title">
            <b-icon-check-circle class="mr-2"></b-icon-check-circle>
            <span>{{ $t("reusable.common.assigned") }}</span>
          </div>
          <div class="header-count">
            <b-badge variant="success" pill>{{
              users_container_right.length
            }}</b-badge>
          </div>
        </div>
        <div class="table-card-body">
          <GenericBTable
            :display_id="'GenericBTable_' + key_component"
            :items="users_container_right"
            :fields="fields2"
            :selection_mode="allows_crud"
            :show_pagination="true"
            :pagination="10"
            :select_mode="'range'"
            @selected="slotSelectedRight"
            @actual_items="actualItemsRight"
          >
            <template #head(selected)>
              <div class="d-flex text-left">
                <b-checkbox
                  v-model="all_selected_right"
                  @change="checkSelectAllRight"
                  v-b-tooltip.top.v-secondary.noninteractive="{
                    title: $t('reusable.common.selectAll'),
                    boundary: 'viewport',
                  }"
                ></b-checkbox>
              </div>
            </template>
            <template #cell(selected)="row">
              <div class="d-flex">
                <b-checkbox
                  class="ml-auto mr-auto"
                  :checked="
                    right_selected_user.some((x) => x.id == row.item.id)
                  "
                  @change="changeUnselectedAvaible(row.item)"
                ></b-checkbox>
              </div>
            </template>
            <template #cell(name)="row">
              {{ row.item.first_name }} {{ row.item.last_name }}
            </template>
            <template #cell(egress_profile)="row">
              <span v-if="row.item.student_card">
                {{ getEgressProfileName(row.item.student_card.egress_profile) }}
              </span>
            </template>
          </GenericBTable>
        </div>
      </div>
    </div>

    <!-- Modal de Búsqueda por Correos -->
    <b-modal
      v-model="showEmailSearchModal"
      :title="$t('section.sectionView.emailQuickSearchTitle')"
      @hide="beforeCloseEmailSearchModal"
      :hide-footer="!search_executed || emails_found.length === 0"
      :ok-title="$t('section.sectionView.selectFoundEmails')"
      :cancel-title="$t('reusable.common.close')"
      size="xl"
      @ok="selectFoundEmails"
    >
      <div class="email-search-container">
        <p class="text-muted mb-3">
          {{ $t("section.sectionView.emailSearchInstruction") }}
        </p>
        <b-form-textarea
          v-model="email_search_input"
          :placeholder="$t('section.sectionView.emailSearchPlaceholder')"
          rows="6"
          max-rows="10"
        ></b-form-textarea>
        <small class="text-muted">
          {{ $t("section.sectionView.emailSearchMaxLimit", { count: 100 }) }}
        </small>

        <!-- Botón Buscar -->
        <div v-if="!search_executed" class="mt-3">
          <b-button
            variant="primary"
            @click="searchByEmails"
            :disabled="!email_search_input.trim()"
            block
          >
            <b-icon-search class="mr-2"></b-icon-search>
            {{ $t("reusable.common.search") }}
          </b-button>
        </div>

        <!-- Resultados de la búsqueda -->
        <div v-if="search_executed" class="mt-4">
          <hr />
          <!-- Correos ya asignados -->
          <div v-if="emails_already_assigned.length > 0" class="mb-3">
            <h6 class="text-info">
              <b-icon-info-circle-fill class="mr-2"></b-icon-info-circle-fill>
              {{
                $t("section.sectionView.emailsAlreadyAssigned", {
                  count: emails_already_assigned.length,
                })
              }}
            </h6>
            <ul class="list-unstyled ml-4">
              <li
                v-for="(email, index) in emails_already_assigned"
                :key="`assigned-${index}`"
                class="text-info"
              >
                <b-icon-check-circle-fill
                  class="mr-2"
                ></b-icon-check-circle-fill
                >{{ email }}
              </li>
            </ul>
          </div>
          <!-- Correos encontrados -->
          <div v-if="emails_found.length > 0" class="mb-3">
            <h6 class="text-success">
              <b-icon-check-circle-fill class="mr-2"></b-icon-check-circle-fill>
              {{
                $t("section.sectionView.emailsFound", {
                  count: emails_found.length,
                })
              }}
            </h6>
            <ul class="list-unstyled ml-4">
              <li
                v-for="(email, index) in emails_found"
                :key="`found-${index}`"
                class="text-success"
              >
                <b-icon-check class="mr-2"></b-icon-check>{{ email }}
              </li>
            </ul>
          </div>

          <!-- Correos con rol incorrecto -->
          <div v-if="emails_wrong_role.length > 0" class="mb-3">
            <h6 class="text-warning">
              <b-icon-exclamation-triangle-fill
                class="mr-2"
              ></b-icon-exclamation-triangle-fill>
              {{
                $t("section.sectionView.usersWithWrongRole", {
                  count: emails_wrong_role.length,
                })
              }}
            </h6>
            <ul class="list-unstyled ml-4">
              <li
                v-for="(item, index) in emails_wrong_role"
                :key="`wrong-role-${index}`"
                class="text-warning"
              >
                <b-icon-exclamation-triangle
                  class="mr-2"
                ></b-icon-exclamation-triangle>
                {{ item.email }}
                <small>({{ getRequiredRoleText() }})</small>
              </li>
            </ul>
          </div>

          <!-- Correos no encontrados -->
          <div v-if="emails_not_found.length > 0">
            <h6 class="text-danger">
              <b-icon-x-circle-fill class="mr-2"></b-icon-x-circle-fill>
              {{
                $t("section.sectionView.emailsNotFound", {
                  count: emails_not_found.length,
                })
              }}
            </h6>
            <ul class="list-unstyled ml-4">
              <li
                v-for="(email, index) in emails_not_found"
                :key="`not-found-${index}`"
                class="text-danger d-flex align-items-center"
              >
                <b-icon-x class="mr-2"></b-icon-x>{{ email }}
                <ButtonSmall
                  v-if="user && user.is_superuser"
                  :tooltip_text="$t('reusable.common.addUser')"
                  :text_button="``"
                  :click_button="() => openAddUserModal(email)"
                  :icon="'plus'"
                  :custom_class="'ml-2'"
                >
                </ButtonSmall>
              </li>
            </ul>
          </div>

          <!-- Botón para nueva búsqueda -->
          <div class="mt-3">
            <b-button
              variant="secondary"
              @click="resetEmailSearch(false)"
              block
            >
              <b-icon-arrow-counterclockwise
                class="mr-2"
              ></b-icon-arrow-counterclockwise>
              {{ $t("section.sectionView.newSearch") }}
            </b-button>
          </div>
        </div>
      </div>
    </b-modal>

    <!-- Modal para Agregar Usuario -->
    <b-modal
      v-model="showAddUserModal"
      :title="$t('section.sectionView.addNewUser')"
      @hide="
        () => {
          newUser = null;
        }
      "
      hide-footer
      size="lg"
    >
      <UserForm
        :User="newUser"
        :allows_crud="allows_crud"
        :Roles="filteredRoles"
        :IdentifierTypes="identifier_types"
        @created="handleUserCreated"
      ></UserForm>
    </b-modal>
  </div>
</template>

<script>
import * as names from "@/store/names";
import { groupUserUrl } from "@/utils/globals";
import { mapGetters } from "vuex";
import { generateUniqueId, toast } from "@/utils/utils";
export default {
  name: "SectionUserList",
  components: {
    NewGenericBTable: () => import("@/components/reusable/NewGenericBTable"),
    GenericBTable: () => import("@/components/reusable/GenericBTable"),
    ButtonSmall: () =>
      import("@/components/reusable/Buttons/Small/ButtonSmall"),
    UserForm: () => import("@/components/users/UserForm.vue"),
  },
  props: {
    section_id: {
      type: [Number, String],
    },
    users_ids: {
      type: Array,
    },
    filter_by_student: {
      type: Boolean,
      default: true,
    },
    allows_crud: {
      type: Boolean,
      default: false,
    },
    key_component: {
      type: String,
    },
    pre_filter_array: {
      type: Array,
      default() {
        return [];
      },
    },
    // Nombre del grupo al que se restringe la lista de disponibles ('ESTUDIANTES', 'PROFESORES')
    required_group_name: {
      type: String,
      default: "",
    },
    identifier_types: {
      type: Array,
      default() {
        return [];
      },
    },
    roles: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      input_search: "",
      input_search_2: "",
      select_all_unavailable: false,
      generic_table_key: 0,
      users_container_right: [],
      left_selected_user: [],
      right_selected_user: [],
      current_page: 1,
      current_tag: [],
      all_selected: false,
      all_selected_right: false,
      current_users: [],
      current_users_right: [],
      showEmailSearchModal: false,
      email_search_input: "",
      emails_found: [],
      emails_not_found: [],
      emails_already_assigned: [],
      emails_wrong_role: [],
      search_executed: false,
      found_users: [],
      showAddUserModal: false,
      newUser: "",
    };
  },
  computed: {
    ...mapGetters({
      user: "getUser",
      users: names.USERS,
      sections: names.SECTIONS,
      egress_profiles: names.EGRESS_PROFILES,
      rolesFromStore: names.ROLES,
    }),
    allRoles() {
      // Usar roles de props si están disponibles, sino del store
      return this.roles && this.roles.length > 0
        ? this.roles
        : this.rolesFromStore;
    },
    filteredRoles() {
      // Si no hay filtro, retornar todos los cargos
      if (!this.required_group_name) {
        return this.allRoles;
      }

      // El cargo cuelga de un grupo; se compara ese grupo, no el nombre del cargo
      return this.allRoles.filter(
        (role) => role.group__name == this.required_group_name
      );
    },
    group_user_url() {
      return groupUserUrl(this.required_group_name);
    },
    available_users_url() {
      return this.group_user_url || "/authentication/user/";
    },
    pre_filter() {
      // Con endpoint propio del grupo, el alcance y la forma los impone la ruta.
      // Sin él se cae al listado general y hay que pedir ambas cosas por query.
      let partial_url = this.group_user_url
        ? []
        : ["picker=True", `groups__name=${this.required_group_name}`];
      // Solo se excluyen los ya asignados. La selección pendiente se ve marcada
      // en su fila, sin volver a consultar al servidor en cada clic.
      const excludedIds = this.users_container_right.map((x) => x.id);

      if (excludedIds.length > 0) {
        partial_url.push(`id__exclude__in=${excludedIds.join(",")}`);
      }

      if (this.pre_filter_array.length > 0) {
        partial_url = partial_url.concat(this.pre_filter_array);
      }
      return partial_url.join("&");
    },
    fields() {
      let list = [];
      if (this.allows_crud)
        list.push({
          key: "selected",
          label: "",
          display_column: true,
          thStyle: "width:25px",
          tdStyle: "width:25px",
        });
      if (this.filter_by_student) {
        return list.concat([
          {
            key: "selected_all",
            label: "",
            display_column: true,
            thStyle: "width:25px",
            tdStyle: "width:25px",
          },
          {
            key: "name",
            sortable: false,
            label: this.$t("reusable.common.name"),
            display_column: true,
          },
          {
            key: "user_data",
            label: this.$t("reusable.common.identifier"),
            sortable: false,
            display_column: true,
            formatter: (value) => {
              return value ? value.identifier : "";
            },
          },
          {
            key: "student_card",
            label: this.$t("reusable.common.cohort"),
            sortable: false,
            display_column: true,
            formatter: (value) => {
              return value ? value.cohort : "";
            },
          },
          {
            key: "egress_profile",
            sortable: false,
            label: this.$getVisibleNames(
              "mesh.egressprofile",
              false,
              "Perfil de Egreso"
            ),
            display_column: true,
            formatter: (value) => this.getEgressProfileName(value),
          },
          {
            key: "role",
            label: this.$t("reusable.common.role"),
            sortable: false,
            display_column: false,
            formatter: (value) => this.getRoleName(value),
          },
        ]);
      } else
        return list.concat([
          {
            key: "name",
            sortable: false,
            label: this.$t("reusable.common.name"),
            display_column: true,
          },
          {
            key: "user_data",
            label: this.$t("reusable.common.identifier"),
            sortable: false,
            display_column: true,
            formatter: (value) => {
              return value ? value.identifier : "";
            },
          },
          {
            key: "role",
            label: this.$t("reusable.common.role"),
            sortable: false,
            display_column: false,
            formatter: (value) => this.getRoleName(value),
          },
        ]);
    },

    fields2() {
      let list = [];
      if (this.allows_crud)
        list.push({
          key: "selected",
          label: "",
          display_column: true,
          thStyle: "width:25px",
          tdStyle: "width:25px",
        });
      if (this.filter_by_student) {
        return list.concat([
          {
            key: "name",
            sortable: false,
            label: this.$t("reusable.common.name"),
            display_column: true,
          },
          {
            key: "user_data",
            label: this.$t("reusable.common.identifier"),
            sortable: false,
            display_column: true,
            formatter: (value) => {
              return value ? value.identifier : "";
            },
          },
          {
            key: "student_card",
            label: this.$t("reusable.common.cohort"),
            sortable: false,
            display_column: true,
            formatter: (value) => {
              return value ? value.cohort : "";
            },
          },
          {
            key: "egress_profile",
            sortable: false,
            label: this.$getVisibleNames(
              "mesh.egressprofile",
              false,
              "Perfil de Egreso"
            ),
            display_column: true,
            formatter: (value) => {
              return this.getEgressProfileName(value);
            },
          },
          {
            key: "role",
            label: this.$t("reusable.common.role"),
            sortable: false,
            display_column: false,
            formatter: (value) => this.getRoleName(value),
          },
        ]);
      } else
        return list.concat([
          {
            key: "name",
            sortable: false,
            label: this.$t("reusable.common.name"),
            display_column: true,
          },
          {
            key: "user_data",
            label: this.$t("reusable.common.identifier"),
            sortable: false,
            display_column: true,
            formatter: (value) => {
              return value ? value.identifier : "";
            },
          },
          {
            key: "role",
            label: this.$t("reusable.common.role"),
            sortable: false,
            display_column: false,
            formatter: (value) => this.getRoleName(value),
          },
        ]);
    },
    section() {
      return this.sections.find((x) => x.id == this.section_id);
    },
  },
  methods: {
    actualItems(items) {
      this.current_users = items;
    },
    actualItemsRight(items) {
      this.current_users_right = items;
    },
    checkSelectAll(checked) {
      this.all_selected = checked;

      if (checked) {
        this.current_users.forEach((item) => {
          if (!this.left_selected_user.some((x) => x.id == item.id)) {
            this.left_selected_user.push(item);
          }
        });
      } else {
        this.current_users.forEach((item) => {
          const index = this.left_selected_user.findIndex(
            (x) => x.id == item.id
          );
          if (index != -1) {
            this.left_selected_user.splice(index, 1);
          }
        });
      }
      this.all_selected = false;
    },
    checkSelectAllRight(checked) {
      if (checked) {
        this.current_users_right.forEach((item) => {
          if (!this.right_selected_user.some((x) => x.id == item.id)) {
            this.right_selected_user.push(item);
          }
        });
      } else {
        this.current_users_right.forEach((item) => {
          const index = this.right_selected_user.findIndex(
            (x) => x.id == item.id
          );
          if (index != -1) {
            this.right_selected_user.splice(index, 1);
          }
        });
      }
    },
    refreshAvailable() {
      // Refresca la tabla de disponibles sin remontarla: conserva página, búsqueda
      // y columnas, y evita el parpadeo del remonte por :key
      this.$nextTick(() => {
        const table = this.$refs.available_table;
        if (table) table.fetchData(this.current_page || 1);
        else this.generic_table_key++;
      });
    },
    changeSelectedAvaible(item) {
      const index = this.left_selected_user.findIndex((x) => x.id == item.id);
      if (index != -1) this.left_selected_user.splice(index, 1);
      else this.left_selected_user.push(item);
    },
    changeUnselectedAvaible(item) {
      const index = this.right_selected_user.findIndex((x) => x.id == item.id);
      if (index != -1) this.right_selected_user.splice(index, 1);
      else this.right_selected_user.push(item);
    },
    clearAllSelected() {
      this.left_selected_user = [];
    },
    loadAssignedUsers() {
      // La sección trae a sus usuarios anidados con ?expand=, así la tabla de la
      // derecha se arma sin pedir nada a authentication/user.
      if (this.section_id && !isNaN(this.section_id)) {
        this.$store
          .dispatch(names.FETCH_SECTION, {
            section_id: this.section_id,
            expand: ["students", "professors"],
          })
          .then((section) => {
            const detail =
              (this.filter_by_student
                ? section.students_detail
                : section.professors_detail) || [];
            // Sin users_ids el padre no lleva la cuenta: valen todos los de la sección
            if (!this.users_ids) {
              this.users_container_right = detail.slice();
              this.refreshAvailable();
              return;
            }
            this.resolveAssignedUsers(detail);
          });
        return;
      }
      if (!this.users_ids || this.users_ids.length == 0) return;
      this.fetchUsersById(this.users_ids).then((users) => {
        this.users_container_right = users;
        this.refreshAvailable();
      });
    },
    resolveAssignedUsers(detail) {
      const by_id = new Map(detail.map((x) => [x.id, x]));
      const apply = () => {
        this.users_container_right = this.users_ids
          .map((id) => by_id.get(id))
          .filter(Boolean);
        this.refreshAvailable();
      };
      apply();
      // Selección sin guardar: esos usuarios todavía no están en la sección del
      // servidor, así que hay que resolverlos aparte
      const missing = this.users_ids.filter((id) => !by_id.has(id));
      if (missing.length == 0) return;
      this.fetchUsersById(missing).then((users) => {
        users.forEach((user) => by_id.set(user.id, user));
        apply();
      });
    },
    fetchUsersById(ids) {
      return this.$restful
        .GetAll(
          `/authentication/user/?picker=True&id__in=${ids.join(
            ","
          )}`
        )
        .then((results) => results);
    },
    getEgressProfileName(value) {
      const egress_profile = this.egress_profiles.find((x) => x.id == value);
      if (egress_profile) return egress_profile.name;
      return "";
    },
    getRoleName(value) {
      const rol = this.allRoles.find((x) => x.id == value);
      if (rol) return rol.position_name;
      return "";
    },
    currentPage(current_page) {
      this.current_page = current_page;
    },
    currentTag(current_tag) {
      this.current_tag = current_tag;
    },
    slotSelectedRight(rows) {
      this.right_selected_user = rows;
    },
    moveToSelected() {
      const left_selected_user = this.left_selected_user;
      left_selected_user.forEach((user, index) => {
        if (!this.users_container_right.find((x) => x.id == user.id))
          this.users_container_right.push(user);
        if (left_selected_user.length == index + 1) {
          this.left_selected_user = [];
          this.refreshAvailable();
          this.$emit("changed", this.users_container_right);
        }
      });
    },
    moveToUnSelected() {
      const right_selected_user = this.right_selected_user;
      right_selected_user.forEach((user, index) => {
        const index_user = this.users_container_right.findIndex(
          (x) => x.id == user.id
        );
        if (index_user != -1) this.users_container_right.splice(index_user, 1);
        if (right_selected_user.length == index + 1) {
          this.right_selected_user = [];
          this.all_selected_right = false;
          this.refreshAvailable();
          this.$emit("changed", this.users_container_right);
        }
      });
    },
    openEmailSearchModal() {
      this.showEmailSearchModal = true;
    },
    beforeCloseEmailSearchModal(event) {
      // Si hay una búsqueda ejecutada y el usuario intenta cerrar el modal
      if (this.search_executed) {
        // Prevenir el cierre automático
        event.preventDefault();

        // Mostrar confirmación
        this.$swal({
          title: this.$t("section.sectionView.confirmCloseSearch"),
          text: this.$t("section.sectionView.confirmCloseSearchText"),
          type: "warning",
          showCancelButton: true,
          confirmButtonText: this.$t("section.sectionView.yesClose"),
          cancelButtonText: this.$t("reusable.common.cancel"),
        }).then((result) => {
          if (result.value) {
            // Usuario confirmó, cerrar el modal y limpiar
            this.showEmailSearchModal = false;
            this.resetEmailSearch();
          }
        });
      } else {
        // Si no hay búsqueda ejecutada, permitir cerrar normalmente
        this.resetEmailSearch();
      }
    },
    searchByEmails() {
      if (!this.email_search_input.trim()) {
        return;
      }
      const emails = this.email_search_input
        .split(",")
        .map((email) => email.trim())
        .filter((email) => email.length > 0)
        .slice(0, 100);
      if (emails.length > 0) {
        // Separar los correos ya asignados ANTES del fetch
        const assignedEmails = this.users_container_right.map(
          (user) => user.email
        );
        this.emails_already_assigned = emails.filter((email) =>
          assignedEmails.includes(email)
        );

        // Solo buscar los correos que NO están ya asignados
        const emailsToSearch = emails.filter(
          (email) => !this.emails_already_assigned.includes(email)
        );

        // Si hay correos para buscar, hacer el fetch
        if (emailsToSearch.length > 0) {
          this.$restful
            .Get(
              `/authentication/user/?picker=True&email__in=${emailsToSearch.join(
                ","
              )}&page_size=100`
            )
            .then((response) => {
              // Guardar los usuarios encontrados completos
              const users = response.results || response;

              // Separar usuarios por rol
              const usersWithCorrectRole = [];
              const usersWithWrongRole = [];

              users.forEach((user) => {
                // Verificar si el usuario tiene el rol requerido
                if (this.hasRequiredRole(user)) {
                  usersWithCorrectRole.push(user);
                } else {
                  usersWithWrongRole.push(user);
                }
              });

              this.found_users = usersWithCorrectRole;

              // Obtener los emails encontrados con rol correcto
              this.emails_found = usersWithCorrectRole.map(
                (user) => user.email
              );

              // Obtener los emails con rol incorrecto
              this.emails_wrong_role = usersWithWrongRole.map((user) => ({
                email: user.email,
                user: user,
              }));

              // Obtener los emails no encontrados
              const allFoundEmails = [
                ...this.emails_found,
                ...this.emails_wrong_role.map((x) => x.email),
              ];
              this.emails_not_found = emailsToSearch.filter(
                (email) => !allFoundEmails.includes(email)
              );

              this.search_executed = true;
            });
        } else {
          // Si todos los correos ya están asignados, marcar como ejecutado sin fetch
          this.emails_found = [];
          this.emails_not_found = [];
          this.emails_wrong_role = [];
          this.found_users = [];
          this.search_executed = true;
        }
      }
    },
    selectFoundEmails() {
      // Agregar solo los usuarios encontrados que NO están ya asignados
      const usersToSelect = this.found_users.filter(
        (user) => !this.users_container_right.some((x) => x.id === user.id)
      );

      usersToSelect.forEach((user, index) => {
        if (!this.left_selected_user.some((x) => x.id == user.id)) {
          this.left_selected_user.push(user);
        }
        if (usersToSelect.length == index + 1) this.moveToSelected();
      });
      // Cerrar el modal
      this.left_selected_user = [];
      this.email_search_input = "";
      this.search_executed = false;
      this.refreshAvailable();
      toast(this.$t("section.sectionView.usersAssigned"));
      this.showEmailSearchModal = false;
    },
    resetEmailSearch(reset_search = true) {
      if (reset_search) this.email_search_input = "";
      this.emails_found = [];
      this.emails_not_found = [];
      this.emails_already_assigned = [];
      this.emails_wrong_role = [];
      this.found_users = [];
      this.search_executed = false;
      this.searchByEmails();
    },
    hasRequiredRole(user) {
      // Si no hay filtro de grupo, aceptar todos
      if (!this.required_group_name) {
        return true;
      }

      // La pertenencia al grupo la declara el serializer en group_names
      return (user.group_names || []).includes(this.required_group_name);
    },
    getRequiredRoleText() {
      if (!this.required_group_name) {
        return this.$t("section.sectionView.roleNotSpecified");
      }
      return this.$t("section.sectionView.roleRequired", {
        roles: this.required_group_name,
      });
    },
    openAddUserModal(email) {
      this.newUser = {
        id: generateUniqueId(),
        first_name: "",
        last_name: "",
        email: email,
        password: "",
        is_active: true,
        is_staff: false,
        is_superuser: false,
        gender: 2,
        birth_date: null,
        school: null,
      };
      this.showAddUserModal = true;
    },
    handleUserCreated(user) {
      // Volver a buscar el usuario completo con todos sus datos
      this.$store
        .dispatch(names.FETCH_USER, { user_id: user.id, force: true })
        .then(() => {
          // Actualizar la búsqueda con el usuario completo
          this.showAddUserModal = false;
          this.resetEmailSearch(false);
        })
        .catch(() => {
          // Si falla, simplemente resetear la búsqueda
          this.showAddUserModal = false;
          this.resetEmailSearch(false);
        });
    },
  },
  watch: {},
  created() {
    this.loadAssignedUsers();
  },
};
</script>

<style scoped>
span >>> .clean-all {
  color: red;
}
.user-list-section-container {
  width: 100%;
}

/* Badges de Seleccionados */
.selected-badges-container {
  background: #e7f3ff;
  border: 1px solid #b3d9ff;
  border-radius: 8px;
  padding: 0.75rem 1rem;
  margin-bottom: 1.5rem;
}

.selected-badges-header {
  display: flex;
  align-items: center;
  color: #0056b3;
  font-size: 0.95rem;
  margin-bottom: 0.5rem;
}

.selected-badges-list {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.badge-user-selected {
  display: inline-flex;
  align-items: center;
  padding: 0.4rem 0.75rem;
  font-size: 0.85rem;
  background-color: #007bff;
  border: none;
  cursor: default;
  transition: all 0.2s;
}

.badge-user-selected:hover {
  background-color: #0056b3;
}

.close-badge-icon {
  cursor: pointer;
  transition: transform 0.2s;
}

.close-badge-icon:hover {
  transform: scale(1.2);
}

/* Grid de Tablas */
.tables-grid {
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  gap: 1rem;
  align-items: start;
}

/* Tarjetas de Tabla */
.table-card {
  background: white;
  border: 1px solid #dee2e6;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.table-card-header {
  background: linear-gradient(135deg, #3a7bd5 0%, #3e84e6 100%);
  color: white;
  padding: 1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.assigned-card .table-card-header {
  background: linear-gradient(135deg, #28a745 0%, #2ebd4f 100%);
}

.header-title {
  display: flex;
  align-items: center;
  font-weight: 600;
  font-size: 1rem;
}

.header-count {
  font-size: 0.9rem;
}

.table-card-body {
  padding: 0;
}

/* Botones de Transferencia */
.transfer-buttons-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 0.75rem;
  padding: 0 0.5rem;
}

.transfer-button {
  width: 45px;
  height: 45px;
  border-radius: 50%;
  border: 2px solid #007bff;
  background-color: white;
  color: #007bff;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.transfer-button:hover:not(:disabled) {
  background-color: #007bff;
  color: white;
  transform: scale(1.1);
  box-shadow: 0 4px 8px rgba(0, 123, 255, 0.3);
}

.transfer-button:active:not(:disabled) {
  transform: scale(0.95);
}

.transfer-button:disabled {
  opacity: 0.4;
  cursor: not-allowed;
  border-color: #dee2e6;
  color: #6c757d;
}

.transfer-spacer {
  width: 45px;
}

/* Responsive */
@media (max-width: 1200px) {
  .tables-grid {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }

  .transfer-buttons-container {
    flex-direction: row;
    justify-content: center;
    order: 2;
  }

  .available-card {
    order: 1;
  }

  .assigned-card {
    order: 3;
  }

  .transfer-button-right {
    transform: rotate(90deg);
  }

  .transfer-button-left {
    transform: rotate(90deg);
  }

  .transfer-button-right:hover:not(:disabled) {
    transform: rotate(90deg) scale(1.1);
  }

  .transfer-button-left:hover:not(:disabled) {
    transform: rotate(90deg) scale(1.1);
  }
}

@media (max-width: 768px) {
  .selected-badges-container {
    padding: 0.5rem;
  }

  .badge-user-selected {
    font-size: 0.75rem;
    padding: 0.3rem 0.6rem;
  }

  .table-card-header {
    padding: 0.75rem;
    font-size: 0.9rem;
  }
}
</style>